import GreenYellowUnderlineSVG from 'assets/svgs/green-yellow-underline.svg'
import BlackUnderlineSVG from 'assets/svgs/black-underline.svg'
import BlueUnderlineSVG from 'assets/svgs/blue-underline.svg'
import HighlightUnderlineSVG from 'assets/svgs/highlight-underline.svg'
import BlueUnderlineRoundedSVG from 'assets/svgs/blue-underline-rounded.svg'
import YellowUnderlineSVG from 'assets/svgs/yellow-underline.svg'
import styled from '@emotion/styled'

export const greenYellowUnderline = {
  width: 'fit-content',
  borderImageSource: `url(${GreenYellowUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 35px 0',
  borderImageSlice: '100% 0',
  borderBottom: '1.2rem solid',
  font: 'inherit',
} as const

export const GreenYellowUnderline = styled.em(greenYellowUnderline)

export const blackUnderline = {
  width: 'fit-content',
  borderImageSource: `url(${BlackUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 7px 0',
  borderImageSlice: '100% 0',
  borderBottom: '7px solid',
  font: 'inherit',
} as const

export const BlackUnderline = styled.em(blackUnderline)

export const highlightUnderline = {
  width: 'fit-content',
  borderImageSource: `url(${HighlightUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 18px 0',
  borderImageSlice: '100% 0',
  borderBottom: '14px solid',
  font: 'inherit',
} as const

export const HighlightUnderline = styled.em(highlightUnderline)

export const yellowUnderline = {
  width: 'fit-content',
  borderImageSource: `url(${YellowUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 27px 0',
  borderImageSlice: '100% 0',
  borderBottom: '0px solid',
  font: 'inherit',
} as const

export const YellowUnderline = styled.em(yellowUnderline)

export const blueUnderline = {
  width: 'fit-content',
  borderImageSource: `url(${BlueUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 11px 0',
  borderImageSlice: '100% 0',
  borderBottom: '11px solid',
  font: 'inherit',
} as const

export const BlueUnderline = styled.em(blueUnderline)

export const blueUnderlineRounded = {
  width: 'fit-content',
  borderImageSource: `url(${BlueUnderlineRoundedSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 11px 0',
  borderImageSlice: '100% 0',
  borderBottom: '11px solid',
  font: 'inherit',
} as const

export const BlueUnderlineRounded = styled.em(blueUnderlineRounded)

export const greenYellowUnderlineV2 = {
  width: 'fit-content',
  borderImageSource: `url(${GreenYellowUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 22px 0',
  borderImageSlice: '100% 0',
  borderBottom: '0.6rem solid',
  font: 'inherit',
} as const

export const GreenYellowUnderlineV2 = styled.em(greenYellowUnderlineV2)

export const greenYellowUnderlineV3 = {
  width: 'fit-content',
  borderImageSource: `url(${GreenYellowUnderlineSVG})`,
  borderImageRepeat: 'stretch',
  borderImageWidth: '0 0 12px 0',
  borderImageSlice: '100% 0',
  borderBottom: '0.3rem solid',
  font: 'inherit',
} as const

export const GreenYellowUnderlineV3 = styled.em(greenYellowUnderlineV3)
